<template>
    <div class="home" v-loading="loading"  element-loading-text="游戏准备中，请稍候">
        <div class="main-content" data-v-2ec16703=""><!---->
            <video v-if="!clientRuning" :src="bg" muted="muted"
                   autoplay="autoplay" loop="loop" class="bg"></video>
            <div class="top-container">
            </div>
            <GameInfo :supportInstall="supportInstall" :limitTime="limitTime" :share_link="share_link" :wdId="wd_id" :account="account" :token="token" v-show="clientRuning" @buyTime="buyTime" @submitSave="submitSave" @copy="copy" @exitGame="exitGame"
                      class="home-header">
                <div class="game-box">
                    <div class="game-info-item">
                        <div class="game-label">延时：</div>
                        <div class="game-value" :class="netWorkDelay >= 80 ? 'color-red' : ''">{{netWorkDelay}}MS</div>
                    </div>
                    <div class="game-info-item">
                        <div class="game-label">丢包率：</div>
                        <div class="game-value" :class="packetLossRate >= 1 ? 'color-red' : ''">{{parseInt(packetLossRate * 100)}}%</div>
                    </div>
                    <div class="game-info-item">
                        <div class="game-label">FPS：</div>
                        <div class="game-value" :class="fps < 30 ? 'color-red' : ''">{{fps}}</div>
                    </div>
                    <div class="game-info-item">
                        <div class="game-label">码率：</div>
                        <div class="game-value">{{bitrate}}</div>
                    </div>
                </div>
            </GameInfo>
<!--            首页-->
            <div class="home-info" v-if="process==1" key="home-info">
                <div class="home-left">
                    <img v-if="desc" :src="desc" alt="">
                </div>
                <div class="home-right">
                    <HomeRight :tip="tip" :channel_id="channel_id" :lunbo="lunbo" :supportInstall="supportInstall" :limitTime="limitTime" :downloadUrl="downloadUrl" ref='myLogin' :account="account" :token="token" @buyTime="buyTime" @startGame="startGame" @login="login" v-show="!clientRuning" @submitSave="submitSave" @signOut="signOut" @log="setClientLog"></HomeRight>
                </div>
            </div>
<!--            游戏页-->
            <div id="cgameLayer" key="cgame-layer" :class="{ visible: process === 3 }"></div>
<!--            排队页面-->
            <queue v-show="process==4" :seatNo="person" :queuingSize="queuingSize" :canceling="queueCanceling" @cancelQueue="cancelQueue"></queue>
<!--            支付页-->
            <rechargeDialog v-if="showRecharge" :left_exp_time="left_exp_time" :downloadUrl="downloadUrl" :anti_level="anti_level" :forbid_game="forbid_game" @close="closeRechargeDialog" @emitGetAccount="emitGetAccount" @rechargeSuccess="rechargeSuccess"></rechargeDialog>
<!--            充值页-->
            <rechargeNow @buyTime="buyTime" :limitTime="limitTime" v-if="process==2" @signOut="signOut"></rechargeNow>
            <pop-up :showClose="false" width="500" height="350" title="实名认证" v-if="showAnti">
                <div class="anti-main">
                    <div class="anti-input-box">
                        <el-input v-model="commonRule.name" placeholder="请输入真实姓名"></el-input>
                        <el-input v-model="commonRule.id_card" placeholder="请输入身份证号码"></el-input>
                    </div>
                    <div v-if="antiReasonShow" class="refuse-result">实名认证未通过</div>
                </div>
                <template v-slot:footer>
                    <div class="anti-footer">
                        <div class="cancel-btn" @click="cancelAnti">取消</div>
                        <div @click="sureAnti">确认</div>
                    </div>
                </template>
            </pop-up>
            <!--            </div>-->
            <media v-if="!clientRuning" :medias="third" :wdId="wd_id" :account="account"></media>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import Header from '@/components/Header.vue'
import HomeRight from '@/components/HomeRight.vue'
import api from '@/utils/api'
import GameInfo from '@/components/GameInfo.vue'
import rechargeNow from '@/components/rechargeNow.vue'
import queue from '@/components/queue.vue'
import rechargeDialog from '@/components/rechargeDialog.vue'
import { mapMutations } from 'vuex'
import popUp from '@/components/popUp.vue'
import {
    DEFAULT_DOWNLOAD_4399_URL,
    DEFAULT_DOWNLOAD_URL,
    getUniqueBrowserId,
    isIdCard,
    secondsToTime
} from '@/utils/util'
import { Loading } from 'element-ui'
import media from '@/components/media.vue'
import { getCloudGameConfig } from '@/services/cloud-game/config.mjs'
import { createWelinkAdapter } from '@/services/cloud-game/welink-adapter.mjs'
import { createSessionController } from '@/services/cloud-game/session-controller.mjs'
import { SESSION_STATE } from '@/services/cloud-game/session-state.mjs'
import {
    enterCloudGameFullscreenLock,
    exitCloudGameFullscreenLock
} from '@/services/cloud-game/fullscreen-keyboard-lock.mjs'

let timer = null // 实名认证loading
let accountInterval = null // 账户余额刷新定时器
let timeLimit = null // 倒计时计时器
let deferredPrompt;

export default {
    name: 'HomeView',
    components: {
        GameInfo,
        media,
        rechargeNow,
        queue,
        popUp,
        rechargeDialog,
        HomeRight,
    },
    computed: {
        process () {
            return this.$store.state.process
        },
        is4399 () {
            return this.$store.state.is4399
        },
    },
    data () {
        return {
            secondsToTime,
            downloadUrl: '',
            isLX: false,
            from: 'website',
            type_0: '', // id为0的状态, 第一次退出登录的标记
            type_1: '', // id为1的状态，第一次弹出访问官网的标记
            type_2: '', // id为2的状态，第一次点击gameInfo里退出游戏的弹窗标记
            token: '', // web Token
            clientToken: '', // 客户端token
            channel_ad_id: '', // 用户广告id
            sub_channel_id: 4261, // 用户子渠道id
            channel_id: 1,
            anti_level: 0, // 实名认证状态 0 未实名 1实名成年 2实名未成年
            forbid_game: 1, // 0 不禁止进入游戏 1未成年禁止进入游戏
            is_test_account: false, // 账号白名单 false 非白名单成员  true 白名单成员
            server_status: false, // 服务器状态 false 未开服 true 开服
            real_name_url: '', // 4399实名认证连接
            showRecharge: false,
            clientRuning: false, // 游戏是否启动中
            loading: false, // 加载状态
            showAnti: false, // 显示实名认证弹窗
            antiReasonShow: false, // 实名认证结果是否展示
            wd_id: 0,
            share_link: '',  // 分享链接
            is_audit: '',
            commonRule: {
                name: '',
                id_card: '',
            },
            supportInstall: false, // 浏览器是否支持
            netWorkDelay: 0,
            fps: 0,
            bitrate: 0,
            packetLossRate: 0,
            account: '',
            expire_time: '', // 月卡到期时间（时间戳，单位秒）
            ttl: '', // 月卡剩余时长（为0代表月卡已失效）
            left_time: '', // 剩余标准时长（单位：秒）
            left_exp_time: '', // 剩余体验时长（单位：秒）
            limitTime: 0, // 剩余总体时长（单位：秒）
            holdTime: 0, // 排队剩余时间
            user_level: 0, // 级别
            person: 0, // 排队人数
            queuingSize: 0, // 队列总人数
            queueCanceling: false,
            queueNetworkErrorShown: false,
            sessionId: '',
            cloudGameController: null,
            beforeUnloadHandler: null,
            third: [], // 右侧icon
            lunbo: [], // 右上角图片轮播
            tip: '',
            bg: '',
            desc: '',
        }
    },
    async created () {
        const _this = this;
        this.setIs4399(this.$route.query.from === '4399web_2457700002')
        await this.queryDownload();
        // 仅浏览器支持且未安装该应用，以下事件才会触发
        window.addEventListener('beforeinstallprompt', (e) => {
            // Chrome 67 及之前版本，会自动展现安装的 prompt
            // 为了版本统一及用户体验，我们禁止自动展现 prompt
            e.preventDefault();
            // 存放事件用于后续触发
            deferredPrompt = e;
            console.log(deferredPrompt, '--deferredPrompt1---')
            // 展现按钮
            _this.supportInstall = true;
            console.log('您的浏览器支持保存到桌面');
        });
    },
    async mounted () {
        const _this = this;
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register(window.location.origin + '/sw.js')
                .then(registration => {
                    console.log('Service Worker 注册成功：', registration);
                })
                .catch(error => {
                    console.log('Service Worker 注册失败：', error);
                });
        }
        this.setupCloudGame()
        this.setClientLog(8)
        this.queryAd();

        if (this.$route.query.token) {
            api.setAuthToken(this.$route.query.token)

            const newQuery = JSON.parse(JSON.stringify(this.$route.query));
            delete newQuery.token;
            if (newQuery.userData) {
                delete newQuery.userData;
                delete newQuery.expire;
            }
            this.$router.replace({ query: newQuery });
        }
        if (api.getAuthToken()) {
            this.token = api.getAuthToken();
            this.queryClientInfo('login')
        }
    },
    beforeDestroy () {
        clearInterval(timeLimit)
        timeLimit = null;
        clearInterval(accountInterval)
        accountInterval = null;
        if (this.beforeUnloadHandler) {
            window.removeEventListener('beforeunload', this.beforeUnloadHandler)
        }
        this.releaseCloudGameKeyboardLock('component-destroy')
        if (this.cloudGameController) {
            this.cloudGameController.stop('component-destroy')
        }
    },
    methods: {
        ...mapMutations(['setShowLogin', 'setProcess', 'setIs4399', 'setMissionCompleteStatus']),
        async queryDownload () {
            const { from } = this.$route.query;
            if (this.is4399) {
                this.downloadUrl = DEFAULT_DOWNLOAD_4399_URL;
                this.sub_channel_id = 24577;
                this.channel_id = 6;
            } else {
                if (from) {
                    this.from = from;
                    await this.$api.get('/v1/config', { from: this.from }).then((res) => {
                        this.downloadUrl = res.game_download_url || DEFAULT_DOWNLOAD_URL;
                        this.sub_channel_id = res.sub_channel_id || 4261;
                        this.channel_id = res.channel_id || 1;
                    }).catch((e) => {
                        this.$message.error(e.message);
                    })
                } else {
                    this.downloadUrl = DEFAULT_DOWNLOAD_URL
                }
            }
            console.log(this.downloadUrl, '---下载地址： ' + this.downloadUrl)
        },
        showLoginFunc (status, value) {
            this.$refs.myLogin.showLoginFunc(status, value)
        },
        setYunLog (type) {
            const map = {
                'master': "https://log.ssjj.cn/logger/setLog?event=cloudLog",
                'pre': "https://log-uat.ssjj.cn/logger/setLog?event=cloudLog",
            }
            const url = map[process.env.VUE_APP_ENV] ? map[process.env.VUE_APP_ENV] : map.pre

            /**
             *   1: 游戏内（GameInfo组件内）保存桌面按钮
             *   2: 界面右侧（HomeRight组件内）保存桌面按钮
             *   3: 弹窗确认按钮
             *
             */
            let data = {
                type,                                   // 埋点类型
                channel_id: this.channel_id,                          // 渠道
                sub_channel_id: this.sub_channel_id,                   // 子渠道
                device_data: {
                    mac_id: getUniqueBrowserId(),           // mac_id
                },
                attach: this.sessionId,
            };
            if (this.clientToken) {
                data = {
                    ...data,
                    token: this.clientToken,
                    userChannelAdId: this.channel_ad_id ? this.channel_ad_id : 0, // 用户广告渠道ID
                };
            }
            this.$api.post(url, data).then((res) => {
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        setClientLog (type, code) {
            const map = {
                'master': "https://log.ssjj.cn/logger/setLog?event=clientLog",
                'pre': "https://log-uat.ssjj.cn/logger/setLog?event=clientLog",
            }
            const url = map[process.env.VUE_APP_ENV] ? map[process.env.VUE_APP_ENV] : map.pre

                /**
                 *   8: 打开登录器(8)
                 *   9: 登录账号-检测配置(9)
                 *   12: 云端拉起游戏进程成功，玩家已进入游戏(12)
                 *   25: 点击“注册账号”按钮(25)
                 *   29: 玩家注册成功(29)
                 *   38: 展示实名认证(38)
                 *   39: 实名认证失败(39)
                 *   40: 实名认证成功(40)
                 *   41: 防沉迷认证失败(41)
                 *   51: 云游戏开始排队(51)
                 *   52: 云游戏结束排队(52)
                 *   53: 云游戏排队成功(53)
                 *   54: 云游戏排队失败(54)
                 *   55: 云游戏时长不足(55)
                 *   56: 云游戏时长点击充值(56)
                 *   57: 云游戏时长充值成功(57)
                 *   58: 云游戏异常(58)
                 *   60: 云游戏弹窗更新维护(60)
                 *
                 */
            let data = {
                type,                                   // 埋点类型
                channel_id: this.channel_id,                          // 渠道
                sub_channel_id: this.sub_channel_id,                   // 子渠道
                device_data: {
                    mac_id: getUniqueBrowserId(),           // mac_id
                },
                attach: this.sessionId,
            };
            if (this.clientToken) {
                data = {
                    ...data,
                    token: this.clientToken,
                    userChannelAdId: this.channel_ad_id ? this.channel_ad_id : 0, // 用户广告渠道ID
                };
            }
            if (type === 58) {
                data.attach = [this.sessionId, code].filter(Boolean).join(',');
            }
            this.$api.post(url, data).then((res) => {
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        queryAd () {
            this.$api.get('/v1/position', { id: this.is4399 ? '71,72,73,74' : '56,57,90,70' }).then((res) => {
                if (this.is4399) {
                    this.bg = (res && res[71] && res[71][0] && res[71][0].image) || ''; // 视频背景
                    this.desc = (res && res[72] && res[72][0] && res[72][0].image) || ''; //
                    this.lunbo = (res && res[73]) || []; //
                    this.tip = (res && res[74] && res[74][0] && res[74][0].image) || ''; // 启动按钮边上的小图标
                } else {
                    this.bg = (res && res[56] && res[56][0] && res[56][0].image) || ''; // 阿里云游戏主页-背景大图
                    this.desc = (res && res[57] && res[57][0] && res[57][0].image) || ''; // 阿里云游戏主页-描述
                    this.lunbo = (res && res[90]) || []; // 云游戏轮播广告
                    this.tip = (res && res[70] && res[70][0] && res[70][0].image) || ''; // 启动按钮边上的小图标
                }

                console.log(res, '---ad----')
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        async queryUserExit (t) {
            console.log(2)
            await this.$api.get('/v1/cloud/user-exit', {
                t
            }).then((res) => {
                console.log(res, '---sssad----')
                console.log(3)
                this['type_' + t] = 1;
            }).catch((e) => {
                this.$message.error(e.message);
            })
            console.log(4)
        },
        closeRechargeDialog () {
            this.showRecharge = false
        },
        rechargeSuccess () {
            this.setClientLog(57); // 云游戏时长充值成功(57)
            // 充值成功后更新时间
            this.getAccountInfo('recharge');
            this.showRecharge = false
        },
        cancelAnti () {
            this.commonRule = {
                name: '',
                id_card: '',
            }
            this.showAnti = false;
            this.antiReasonShow = false;
            this.clearInfo();
        },

        submitSave () {
            this.checkDialog();
        },
        login (r, type) {
            this.wd_id = r.userData.wd_id;
            this.token = r.token;
            api.setAuthToken(r.token)
            if (r.userData.register) {
                this.setClientLog(29)
            } else {
                this.setClientLog(9)
            }
            this.queryClientInfo(type)
        },
        async checkDialog (cb) {
            let _this = this;
            if (this.supportInstall) {
                this.$confirm(`是否将云游戏添加到桌面，随时畅玩？（您也可以通过快捷键ctrl+D添加页面至收藏夹）`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.setYunLog(3);
                    if (deferredPrompt) {
                        // 展现安装的 prompt
                        deferredPrompt.prompt();
                        // 等待用户对 prompt 进行操作
                        // 如果用户从地址栏或其他浏览器组件安装了PWA，则以下代码将不起作用
                        deferredPrompt.userChoice.then((choiceResult) => {
                            if (choiceResult.outcome === 'accepted') {
                                console.log('点击添加');
                            } else {
                                console.log('取消添加');
                            }
                            deferredPrompt = null;
                        });
                    }
                    cb && cb()
                }).catch((err) => {
                    console.log(err)
                    if (!this.type_1 && err === 'cancel') {
                        this.queryUserExit(1);
                        this.$message({
                            type: 'info',
                            message: '您也可以随时访问官网ssjj.cn，从右上角“云游戏·限时体验”进入'
                        });
                    }
                    cb && cb()
                });
            } else {
                cb && cb()
            }
        },
        logCloudGameDiagnostic (diagnostic) {
            const entry = { ...diagnostic }
            if (!Array.isArray(window.__cloudGameDiagnostics)) {
                window.__cloudGameDiagnostics = []
            }
            window.__cloudGameDiagnostics.push(entry)
            if (window.__cloudGameDiagnostics.length > 300) {
                window.__cloudGameDiagnostics.shift()
            }
            const method = entry.level === 'error' ? 'error' : (entry.level === 'warn' ? 'warn' : 'info')
            console[method]('[CloudGame Diagnostic]', entry)
        },
        setupCloudGame () {
            try {
                const config = getCloudGameConfig(process.env.VUE_APP_ENV)
                const adapter = createWelinkAdapter({ config })
                this.logCloudGameDiagnostic({
                    time: new Date().toISOString(),
                    level: 'info',
                    event: 'browser-environment',
                    userAgent: navigator.userAgent,
                    online: navigator.onLine,
                    secureContext: window.isSecureContext,
                    webTransport: typeof window.WebTransport,
                    webRtc: typeof window.RTCPeerConnection,
                    visibilityState: document.visibilityState,
                    exportCommand: 'copy(JSON.stringify(window.__cloudGameDiagnostics, null, 2))'
                })
                this.cloudGameController = createSessionController({
                    api: this.$api,
                    adapter,
                    config,
                    onState: this.handleCloudGameState,
                    onQueue: queueInfo => {
                        this.person = queueInfo.seatNo
                        this.queuingSize = queueInfo.queuingSize
                        this.queueNetworkErrorShown = false
                    },
                    onFirstFrame: snapshot => {
                        this.sessionId = snapshot.sessionId
                        this.clientRuning = true
                        this.loading = false
                        clearInterval(accountInterval)
                        accountInterval = setInterval(this.getAccountInfo, 5 * 60 * 1000)
                        this.startTimeLimit()
                        this.setClientLog(12)
                    },
                    onStatistics: data => {
                        this.netWorkDelay = Number(data.netWorkDelayUdp || 0)
                        this.fps = Number(data.fps || 0)
                        this.bitrate = Number(data.bitrate || 0)
                        this.packetLossRate = Number(data.packetLossRate || 0) / 100
                    },
                    onRecoverableError: error => {
                        if (!this.queueNetworkErrorShown) {
                            this.queueNetworkErrorShown = true
                            this.$message.warning(error.message || '排队查询失败，正在重试')
                        }
                    },
                    onQueueCancelError: error => {
                        this.setClientLog(58, 'queue-cancel')
                        const detail = error.message ? `：${error.message}` : ''
                        this.$message.warning(`本地已退出排队，云端资源可能延迟释放${detail}`)
                    },
                    onDiagnostic: this.logCloudGameDiagnostic,
                    onError: detail => {
                        this.setClientLog(58, detail.code || detail.phase)
                        if (!detail.error || !detail.error.handled) {
                            this.$message.error(detail.message || '云游戏启动失败，请稍后重试')
                        }
                    },
                    onStopped: (reason, detail) => {
                        this.releaseCloudGameKeyboardLock(reason)
                        this.resetCloudGameView()
                        if (this.token && !['logout', 'component-destroy'].includes(reason)) {
                            this.getAccountInfo(true, detail.sessionId)
                        }
                    }
                })
                this.beforeUnloadHandler = () => {
                    if (this.cloudGameController) {
                        this.cloudGameController.stop('beforeunload')
                    }
                }
                window.addEventListener('beforeunload', this.beforeUnloadHandler)
            } catch (error) {
                this.$message.error(error.message)
            }
        },
        handleCloudGameState (state) {
            if ([SESSION_STATE.PRECHECK, SESSION_STATE.MEASURING, SESSION_STATE.DISPATCHING].includes(state)) {
                this.loading = true
            } else if (state === SESSION_STATE.QUEUING) {
                this.loading = false
                this.setProcess(4)
            } else if (state === SESSION_STATE.STARTING) {
                this.loading = true
                this.setProcess(3)
            } else if ([SESSION_STATE.ERROR, SESSION_STATE.STOPPING, SESSION_STATE.IDLE].includes(state)) {
                this.loading = false
            }
        },
        resetCloudGameView () {
            clearInterval(accountInterval)
            accountInterval = null
            clearInterval(timeLimit)
            timeLimit = null
            this.clientRuning = false
            this.loading = false
            this.queueCanceling = false
            this.queueNetworkErrorShown = false
            this.person = 0
            this.queuingSize = 0
            this.sessionId = ''
            this.setProcess(1)
        },
        createHandledError (message) {
            const error = new Error(message)
            error.handled = true
            return error
        },
        async cloudGamePrecheck () {
            const res = await this.$api.get('/v1/cloud/info')
            this.wd_id = res.wd_id
            this.account = res.account
            this.anti_level = res.anti_level
            this.forbid_game = res.forbid_game
            this.is_test_account = res.is_test_account
            this.server_status = res.server_status
            this.clientToken = res.client_token
            this.channel_ad_id = res.channel_ad_id

            if (process.env.NODE_ENV === 'production') {
                if (!res.server_status && !res.is_test_account) {
                    this.$message.error('游戏尚未开服')
                    throw this.createHandledError('游戏尚未开服')
                }
                if (res.anti_level == 0) {
                    this.$myConfirm({
                        text: '您的账号未进行实名认证，请完成实名认证后再试。',
                        title: '未实名认证',
                        confirmShow: true,
                        cancelShow: true,
                        showClose: false,
                        confirmText: '前往认证',
                    }).then(() => {
                        this.setClientLog(38)
                        if (this.is4399) {
                            window.open(this.real_name_url)
                        } else {
                            this.showAnti = true
                        }
                    }).catch(() => {})
                    throw this.createHandledError('账号未实名认证')
                }
                if (res.anti_level == 2 && res.forbid_game == 1) {
                    this.setClientLog(41)
                    this.$myConfirm({
                        text: '您未满18岁，我们仅会在周五、周六、周日和法定节假日每日20:00~21:00提供一小时的游戏服务。',
                        title: '防沉迷提醒',
                        confirmShow: true,
                        cancelShow: false,
                        showClose: false,
                        confirmText: '关闭',
                    }).catch(() => {})
                    throw this.createHandledError('防沉迷限制进入游戏')
                }
            }
            if (this.limitTime <= 360) {
                this.setClientLog(55)
                this.setProcess(2)
                throw this.createHandledError('可用游戏时长不足')
            }
            return {
                clientToken: this.clientToken,
                channelAdId: this.channel_ad_id
            }
        },
        startWelinkGame () {
            if (!this.token) {
                this.showLoginFunc(true, 'login')
                return
            }
            if (!this.cloudGameController) {
                this.$message.error('云游戏组件尚未准备完成')
                return
            }
            const keyboardLockPromise = this.requestCloudGameKeyboardLock()
            return this.cloudGameController.start({
                precheck: this.cloudGamePrecheck,
                clientToken: this.clientToken,
                channelAdId: this.channel_ad_id
            }).catch(error => {
                keyboardLockPromise.finally(() => this.releaseCloudGameKeyboardLock('start-failed'))
                throw error
            }).catch(() => {})
        },
        startGame () {
            return this.startWelinkGame()
        },
        clearInfo () {
            // 调用时机为： 1、用户登录账号取消实名认证/未成年人禁止进入游戏时    2、结束游戏成功时
            this.token = ''
            this.showRecharge = false
            this.showAnti = false
            this.antiReasonShow = false
            this.wd_id = 0
            api.setAuthToken('')
            this.setProcess(1);
            // 关闭账户信息定时器
            clearInterval(accountInterval)
            accountInterval = null;
            clearInterval(timeLimit)
            timeLimit = null;
            this.forbid_game = ''
            this.is_test_account = ''
        },
        exitGame () {
            if (!this.type_2) {
                this.queryUserExit(2);
                this.checkDialog();
            }
            return this.gameStop('user-exit')
        },
        copy () {
            this.$copyText(this.sessionId).then((e) => {
                this.$message.success('复制成功');
                console.log(e)
            }, function (e) {
                this.$message.error('复制失败');
                console.log(e)
            });
        },
        buyTime () {
            this.setClientLog(56); // 云游戏时长点击充值(56)
            this.showRecharge = true;
        },
        async cancelQueue () {
            if (this.queueCanceling) return
            this.queueCanceling = true
            await this.gameStop('cancel-queue')
        },
        async signOut () {
            if (!this.type_0 && this.supportInstall) {
                this.checkDialog()
                this.queryUserExit(0);
            }
            await this.gameStop('logout')
            this.$api.get('/api/user/logout').then((res) => {
                this.clearInfo();
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        queryClientInfo (type) {
            // 通过接口获取客户端信息（含client token）
            this.$api.get('/v1/cloud/info').then(async (res) => {
                if (res.channel_id == 8) {
                    // 由于联想使用官方登录，因此不能仅仅靠from来判断，只能通过用户信息来判断
                    this.isLX = true
                }
                this.share_link = res.share_link
                this.wd_id = res.wd_id
                this.account = res.account // 账号
                this.clientToken = res.client_token
                this.anti_level = res.anti_level
                this.channel_ad_id = res.channel_ad_id
                // this.sub_channel_id = res.sub_channel_id
                this.forbid_game = res.forbid_game
                this.is_test_account = res.is_test_account
                this.server_status = res.server_status
                this.real_name_url = res.real_name_url
                this.third = res.third || []
                this.type_0 = res.type_0 || 0;
                this.type_1 = res.type_1 || 0;
                this.type_2 = res.type_2 || 0;
                this.setShowLogin(false)

                console.log(process.env.NODE_ENV, '==process.env.NODE_ENV==')
                if (process.env.NODE_ENV === 'development') {
                    this.getAccountInfo(true)
                } else {
                    if (!res.server_status && !res.is_test_account) {
                        this.setClientLog(60); // 云游戏弹窗更新维护(60)
                        // 游戏尚未开服
                        this.$myConfirm({
                            text: '游戏尚未开服。',
                            title: '提示',
                            confirmShow: true,
                            cancelShow: false,
                            showClose: false,
                            confirmText: '确定',
                        })
                    } else if (res.anti_level == 0) {
                        // 未实名
                        this.$myConfirm({
                            text: '您的账号未进行实名认证，请完成实名认证后再试。',
                            title: '未实名认证',
                            confirmShow: true,
                            cancelShow: true,
                            showClose: false,
                            confirmText: '前往认证',
                        }).then(() => {
                            this.setClientLog(38);  // 展示实名认证
                            if (this.is4399) {
                                window.open(this.real_name_url);
                            } else {
                                this.showAnti = true
                            }
                        }).catch((e) => {
                            console.log(e)
                            this.clearInfo();
                            // 取消用户登录状态
                        })
                    } else if (res.anti_level == 2 && res.forbid_game == 1) {
                        // 2实名未成年且未成年禁止进入游戏
                        this.$myConfirm({
                            text: '您未满18岁，我们仅会在周五、周六、周日和法定节假日每日20:00~21:00提供一小时的游戏服务。',
                            title: '防沉迷提醒',
                            confirmShow: true,
                            cancelShow: false,
                            showClose: false,
                            confirmText: '关闭',
                        }).then(() => {
                            this.getAccountInfo(true)
                        }).catch((e) => {
                            console.log(e)
                            this.clearInfo();
                        })
                    } else {
                        this.getAccountInfo(true)
                    }
                }
            }).catch((e) => {
                this.setShowLogin(false)
                this.$message.error(e.message);
                this.token = '';
                api.setAuthToken('')
                this.wd_id = 0;
            })
        },
        emitGetAccount () {
            this.getAccountInfo('recharge')
        },
        // 获取账户信息
        getAccountInfo (notInterval, sessionId = this.sessionId) {
            const params = {
                interval: !notInterval
            }
            if (sessionId) params.session_id = sessionId
            this.$api.get('/v1/cloud/account-info', params).then((res) => {
                console.log(res, ';----')
                this.setMissionCompleteStatus(res.have_rewards);
                this.expire_time = res.expire_time // 月卡到期时间（时间戳，单位秒）
                this.ttl = res.ttl // 月卡剩余时长（为0代表月卡已失效）
                this.left_time = res.left_time // 剩余标准时长（单位：秒）
                this.left_exp_time = res.left_exp_time // 剩余体验时长（单位：秒）
                if (res.user_level) {
                    this.user_level = res.user_level // 用户级别
                }
                let str = ''
                if (res.first_login) {
                    str += `获得新人时长${secondsToTime(res.first_login_reward, 'time')};`
                }
                if (res.daily_login) {
                    str += `每日登录奖励${secondsToTime(res.daily_login_reward, 'time')};`
                }
                if (this.left_exp_time === 1140 * 60) {
                    str += '免费累积时长已达1140分钟上限'
                }
                if (str) {
                    this.$message.success(str);
                }
                let timeNumber = parseInt(res.ttl + res.left_time + res.left_exp_time - res.game_time);
                this.limitTime = timeNumber > 0 ? timeNumber : 0;
                console.log(secondsToTime(this.limitTime, 'day'), '----this.limitTime---')

                if (notInterval === 'recharge') {
                   // 来自充值成功的回调
                   //  this.$message('充值成功')
                    if (this.process === 2 && this.limitTime > 360) {
                        this.setProcess(1);
                    }
                } else if (notInterval) {
                    if (this.limitTime <= 360) {
                        // todo 提示去充值 rechargeNow
                        this.setClientLog(55);  // 云游戏时长不足(55)
                        this.setProcess(2)
                    } else {
                        this.setProcess(1)
                        // this.startGame()
                    }
                } else {
                    // 来自定时器
                    if (this.limitTime <= 360) {
                        this.setClientLog(55);  // 云游戏时长不足(55)
                        this.$message('当前余额所剩不多，请及时充值')
                    }
                    // 先清除之前的倒计时定时器
                    clearInterval(timeLimit)
                    timeLimit = null;
                    // 更新完时间后重新倒计时
                    this.startTimeLimit()
                }
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        // 验证/提交实名信息
        sureAnti () {
            let r = true
            if (!this.commonRule.name.trim().length) {
                r = false
            }
            if (!isIdCard(this.commonRule.id_card)) {
                r = false
            }
            if (!r) {
                this.$message.error('数据有误，请确认后输入');
                return false
            }

            timer = Loading.service({ fullscreen: true })
            this.$api.post('/v1/cloud/real-name', {
                ...this.commonRule
            }).then((res) => {
                console.log(res)
                setTimeout(this.queryAntiStatus, 3000)
            }).catch((e) => {
                timer.close();
                this.$message.error(e.message);
            })
        },
        queryAntiStatus () {
            // 获取实名认证状态
            this.$api.get('/v1/cloud/check-real-name').then((res) => {
                console.log(res)
                timer.close()
                if (res.anti_level == 0) {
                    this.antiReasonShow = true;
                    this.setClientLog(39);  // 实名认证失败(39)
                } else if (res.anti_level == 2 && this.forbid_game == 1) {
                    this.setClientLog(40);  // 防沉迷认证失败，但是属于实名认证成功(40)
                    this.showAnti = false;
                    // 2实名未成年且未成年禁止进入游戏
                    this.$myConfirm({
                        text: '您未满18岁，我们仅会在周五、周六、周日和法定节假日每日20:00~21:00提供一小时的游戏服务。',
                        title: '防沉迷提醒',
                        confirmShow: true,
                        cancelShow: false,
                        confirmText: '关闭',
                    }).then(() => {
                    }).catch((e) => {
                    })
                } else {
                    this.setClientLog(40);  // 实名认证成功(40)
                    this.showAnti = false;
                    this.getAccountInfo(true)
                }
                // 更新实名结果
                this.anti_level = res.anti_level
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        gameStop (reason = 'user-exit') {
            if (!this.cloudGameController) {
                this.releaseCloudGameKeyboardLock(reason)
                this.resetCloudGameView()
                return Promise.resolve()
            }
            return this.cloudGameController.stop(reason)
        },
        requestCloudGameKeyboardLock () {
            this.logCloudGameDiagnostic({
                time: new Date().toISOString(),
                level: 'info',
                event: 'keyboard-lock-request',
                secureContext: window.isSecureContext
            })
            return enterCloudGameFullscreenLock().then(result => {
                this.logCloudGameDiagnostic({
                    time: new Date().toISOString(),
                    level: result.keyboard === 'locked' ? 'info' : 'warn',
                    event: result.keyboard === 'locked' ? 'keyboard-lock-success' : 'keyboard-lock-degraded',
                    result
                })
                return result
            }).catch(error => {
                this.logCloudGameDiagnostic({
                    time: new Date().toISOString(),
                    level: 'warn',
                    event: 'keyboard-lock-fail',
                    message: error.message
                })
                return { fullscreen: 'failed', keyboard: 'failed' }
            })
        },
        releaseCloudGameKeyboardLock (reason) {
            return exitCloudGameFullscreenLock().then(result => {
                this.logCloudGameDiagnostic({
                    time: new Date().toISOString(),
                    level: 'info',
                    event: 'keyboard-lock-release',
                    reason,
                    result
                })
                return result
            }).catch(error => {
                this.logCloudGameDiagnostic({
                    time: new Date().toISOString(),
                    level: 'warn',
                    event: 'keyboard-lock-release-fail',
                    reason,
                    message: error.message
                })
                return { fullscreen: 'failed', keyboard: 'failed' }
            })
        },
        startTimeLimit () {
            // 开始倒计时
            timeLimit = setInterval(() => {
                this.limitTime -= 60;
            }, 60000)
        },
    },
}
</script>
<style scoped lang="less">
#cgameLayer {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    z-index: 50;
}
#cgameLayer.visible {
    visibility: visible;
}
.anti-main {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 10px;
    .refuse-result {
        font-size: 14px;
        color: red;
    }
}
.anti-input-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.anti-footer {
    cursor: pointer;
    color: #fff;
    width: 100%;
    margin: 0 auto;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    > div {
        background: #eb5541;
        padding: 10px 20px;
        border-radius: 7px;
    }
    .cancel-btn {
        background: #d5d5d5;
        margin-right: 10px;
        color: #000;
    }
}

.home-info {
    color: #7289A6;
    z-index: 5;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .home-left {
        flex: 1;
        position: relative;
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        img {
            width: 716px;
            height: 166px;
            margin-bottom: 82px;
        }
    }
    .home-right {
        width: 550px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url("../assets/images/home/home-right-bg.png");
        box-sizing: border-box;
    }

}
.game-box {
    display: flex;
    justify-content: space-between;
    background-image: url("../assets/images/gameInfo/info.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 377px;
    height: 31px;
    align-items: center;
    padding: 0 20px;
    color: #B0CAEB;
    font-size: 12px;
}
.game-info-item {
    display: flex;
}
.game-value {
    color: #53DA56;
}
.color-red {
    color: #da5353;
}

.top-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 150;
}

.main-content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 100vh;
    overflow: hidden;
    text-align: center;
    background-color: #000;
    background-size: 100%;
    background-repeat: no-repeat;

    .home-main {
        width: 100%;
        z-index: 2;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .bg {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
    }
}
</style>
